<template>
  <div>
    <h1>Forbidden</h1>
    <p>很抱歉，你没有相关操作权限，请尝试点击此处 <a :href="loginUrl" target="_blank">登陆</a> </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginUrl: process.env.VUE_APP_API_SERVER,
    }
  },
}
</script>
